import { CursorPosition, useCursorPosition } from './Cursor';
import { StackedTimeSeriesData } from './dataTypes';

export function translateCursorPositionToStackIndex<
  Data extends StackedTimeSeriesData,
>({ cursor, datapoint }: { cursor: CursorPosition; datapoint?: Data }) {
  const cursorY = cursor?.yValue;
  if (cursorY === undefined || !datapoint?.stackCounts) return null;
  let acc = 0;
  const foundIndex = datapoint.stackCounts.findIndex(({ value }) => {
    acc += value;
    return cursorY < acc;
  });
  return foundIndex === -1 ? null : foundIndex;
}

/**
 * Custom hook to get the stack index of the series data that the cursor is currently over.
 * Relies on there being a `yValue` set on the CursorPosition which typically
 * comes from the SVGWrapper's `getCursor`.
 *
 * @param datapoint - A StackedTimeSeriesData.
 *
 * @returns The index of the stack the cursor is currently over.
 *
 */
export function useCursorStackIndex<Data extends StackedTimeSeriesData>({
  datapoint,
}: {
  datapoint?: Data;
}) {
  const cursor = useCursorPosition();
  return translateCursorPositionToStackIndex({ cursor, datapoint });
}
